import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import _ from 'lodash'

class MCTopToast extends Component {


    static lastMessage = null

    toastDuration = 6000

    state = {
        open: false,
        message: {},
    }


    static getDerivedStateFromProps(nextProps) {


        if (MCTopToast.lastMessage  === nextProps.message)
            return null


        if (nextProps.message.content) {

            MCTopToast.lastMessage = nextProps.message

            return {
                open: true,
                message: nextProps.message
            }
        }

        return null
    }


    componentDidUpdate() {
       this.dismiss()
    }


    dismiss = _.debounce(()=>{
        this.setState({
            open: false
        })
    }, this.toastDuration )


    render() {

        const {
            message

        } = this.props

        const {
            type,
            content,
        } = message

        const openCls = this.state.open ? ' open ' : ''

        return (
            <div className={'mc-toptoast ' + type + openCls}>
                {content}
            </div>
        )
    }
}

MCTopToast.propTypes = {
    message: PropTypes.shape({
        content: PropTypes.any,
        type: PropTypes.oneOf(['success', 'error', 'normal']),
    })
}

MCTopToast.defaultProps = {
    message: {
        content: '',
        type: 'normal'
    }

}

export default MCTopToast



// WEBPACK FOOTER //
// ./src/components/_common/TopToast/index.js